module.exports = __webpack_public_path__ + "img/logo.ca8ab15a.svg";